// export enum MDVarmePrimarFjarr {
//   harFlodestaxa = "harFlodestaxa"
// }

import { IPeriod, VeckoSchemaPerioder, WeekDayName } from "./module-type";

export type JaNej = "Ja" | "Nej";
export type JaNejTom = "Ja" | "Nej" | "";

export interface IdText {
  id: any;
  text: string;
}

//1.0 Byggnadsdata & energistatistik
export interface IModuleByggnadsdataConfig {
  företag?: string;
  område?: string;
  adress?: string;
  postnummer?: string;
  ort?: string;
  kommun: string;
  byggnadArea: number;
  verksamhet: string;
  nybyggnadsår: string;
  energikälla: string;
  producerarTappvarmvatten: "Ja" | "Nej" | "";
}
export interface IModuleByggnadsdataRound {
  årligVärmeFörbrukning: number;
  årligEnergiFörbrukning: number;
}
export interface IModuleByggnadsdata extends IModuleByggnadsdataConfig, IModuleByggnadsdataRound {}

//2.0 Lokaler & rum
export interface IModuleLokalerConfig {}
export interface StickProv {
  zon: string;
  värmeSystem: string;
  ventilationsSystem: string;
  uppmättTemperatur: number;
  uppmättTemperaturTilluft: number;
  komfortKylaAktiv: "Ja" | "Nej";
  upplevdKomfort: string;
  ärLuftburenVärme?: boolean; //Indikerar OM zonen är ett luftburet system (D.v.s FT/FTX markerat som huvudsaklig värme). I detta fall ät zon = namnet på systemet ock kan ej modifieras av användaren
  inställningsvärdeTermostat?: number; //Användarens inställning av termostaten i zonen. Om zonen är ett luftburet system så är detta värdet på termostaten i aggregatet.
  note?: string;
}

export interface TemperaturInfoByggnad {
  verksamhet: string;
  uppmättMedeltemperatur: number;
  rekommenderadMedelTemperatur: number;
  diffUppmättMotRekommenderat: number;
  uppmättTempDiff: number;
}

export interface TemperaturInfoStickprov {
  HögstUppmätt: number;
  LägstUppmätt: number;
  MedelUppmätt: number;
}

export interface IModuleLokalerRound {
  stickprov: StickProv[];
}
export interface IModuleLokaler extends IModuleLokalerConfig, IModuleLokalerRound {}

//3.1.1 Fjärrvärme primärsystem
export interface IModuleVärmePrimärFjärrConfig {
  harFlödestaxa?: "Ja" | "Nej";
  flödestaxa?: number;
  användSchablon: boolean;
}
export interface IModuleVärmePrimärFjärrRound {
  mätvärdeM3?: number;
  mätvärdeMWh?: number;
  returTempPrimär?: number;
  returTempSekunär?: number;
  temperaturUtegivare: number;
  saknarMätvärde?: "Ja" | "Nej";
  tilloppstempPrimär?: number;
  tilloppstempSekundär?: number;
}
export interface IModuleVärmePrimärFjärr extends IModuleVärmePrimärFjärrConfig, IModuleVärmePrimärFjärrRound {}

//3.1.2  Värmepump primärvärmesystem (Kontroll värmefaktor)
export interface IModuleVärmePrimärPumpConfig {
  harProduktionVatten?: "Ja" | "Nej";
  harProduktionVärme?: "Ja" | "Nej";
  systemTyp?: string;
}
export interface IModuleVärmePrimärPumpRound {
  årligVärmeproduktion?: number;
  årligElAnvändning?: number;
  uppgiftEnergistatistik?: string;
  ackumuleradeTimmar?: number;
  ackumuleradeDrifttimmar?: number;
  harUppdateratDrifttimmar?: "Ja" | "Nej";
}
export interface IModuleVärmePrimärPump extends IModuleVärmePrimärPumpConfig, IModuleVärmePrimärPumpRound {}

//3.2.1 Vattenburet sekundärvärmesystem i byggnaden
export interface IModuleVattenburetSekundärsystemConfig {
  betjäningsområde: string;
  värmeSystemandel: number;
  elEffekt: number;
}
export interface Värmekurva {
  brytpunktUtetemp?: number;
  brytpunktFramledningstemp?: number;
}
export interface IModuleVattenburetSekundärsystemRound {
  betjäningsområde: string;
  värmeSystemandel: number;
  elEffekt: number;
  framledningBorvarde: number;
  framledningArvarde: number;
  returledningArvarde: number;
  utegivareTemperatur: number;
  varmeventilUtstyrning: number;
  pumpstoppSaknas: boolean;
  pumpstoppInstallning: number;
  pumpstoppKontroll: string;

  värmekurva: Värmekurva[];

  parallellforskjutning?: number;
}
export interface IModuleVattenburetSekundärsystem extends IModuleVattenburetSekundärsystemConfig, IModuleVattenburetSekundärsystemRound {}

//3.3.1 Direktverkande EL värmesystem
export interface IModuleVärmeElConfig {
  betjäningsområde: string;
  värmeSystemandel: number;
  värmeavgivare: string;
  värmeStyrning: string;
  harÖverordnatVärmestopp: "Ja" | "Nej";
}
export interface IModuleVärmeElRound {
  värmestoppInställningsvärde: number;
  värmestoppFunktionskontroll: "" | "Värmeavgivning aktiv" | "Värmeavgivning ej aktiv";
  termostatInställningsvärde: number;
  kontrollVärmestoppFungerar?: "Ja" | "Nej";
  kontrollGivareUtetemperaturFungerar?: "Ja" | "Nej";
}
export interface IModuleVärmeEl extends IModuleVärmeElConfig, IModuleVärmeElRound {}

//4.1.1 Vattenburet kylsystem i byggnaden
// export interface IModuleKylaVattenburetConfig {
//   betjäningsområde: string;
//   frmGemensamBetjäningsytaVärmeModul: string;
//   gemensamBetjäningsytaVärmeModul: number;
//   gemensamBetjäningsytaAndel: number;
// }

export interface IKylaVärmeGemensamYta {
  värmeModulId: number;
  ytaAndel: number;
}
export interface IModuleKylaVattenburetConfig {
  betjäningsområde: string;
  //frmData?: any;
  värmeSystemGemensamBetjäningsyta: IKylaVärmeGemensamYta[];
}
export interface IModuleKylaVattenburetRound {
  kylform: string;
}
export interface IModuleKylaVattenburet extends IModuleKylaVattenburetConfig, IModuleKylaVattenburetRound {}

//4.2.1 Kylmaskin (Kontroll kylfaktor)
export interface IModuleKylmaskinConfig {
  //frmBetjänadeSystem: any;
  //frmData?: any;
  betjänadeSystem: number[];
}
export interface IModuleKylmaskinRound {
  harUppdateradStatistik: "Ja" | "Nej";
  årligAvgivning: number;
  årligElanvändning: number;
}
export interface IModuleKylmaskin extends IModuleKylmaskinConfig, IModuleKylmaskinRound {}

//5.1.1 Ventilationsaggregat (FTX+FT- system)
export interface IModuleVentilationFTXochFTConfig {
  //Generell
  systemtypÅtervinningFTX: string;
  eftervärmningsbatteri: string;
  ärHuvudsakligtVärmesystem: "Ja" | "Nej";
  kylbatteri: string;
  kylform: string;
  harBefuktning: "Ja" | "Nej";
  harLufttork: "Ja" | "Nej";
  //Flöde
  // flödeUppgift: string;
  // flödeEnhet: string;
  // flödeTilluft: number;
  // flödeFrånluft: number;
  // flödesKanalForm: "Cirkulära" | "Rektangulära";
  // flödeKanalstorlekBxH?: string;
  // flödeFrånluftDiameter?: number;
  harReduceradeLuftflödeReglerbaraRumsdon: "Ja" | "Nej";
  reduceratFlödeRumsdonReglerbara: number;
  harReduceradeLuftflödeFastaRumsdon: "Ja" | "Nej";
  reduceratFlödeRumsdonFasta: number;
  variabeltFlödeReglermetod: string;
  harSeparatFrånluftsfläkt: "Ja" | "Nej";
  separatFrånluftsfläktBeteckning: string;
  tillverkningsår: string;
  //MotorEffekt
  motoreffektUppgift: string;
  motoreffektTilluft: number;
  motoreffektFrånluft: number;
}

export enum IModuleVentilationRoundKanaler {
  ventilation = "ventilation",
  närvaro = "närvaro",
}

//Ger ett interface med 2 props (ventilation & närvaro), som vardera är ett objekt med samtliga veckodagar som i sin tur innehåller en IPeriod[]
export interface IModuleVentilationRoundTidskanaler extends Record<IModuleVentilationRoundKanaler, Record<WeekDayName, IPeriod[]>> {}

export interface IModuleVentilationFTXochFTRound {
  //Uppmätta & avlästa temperaturer ventilationsaggregat

  flödeUppgift: string;
  flödeEnhet: string;
  flödeTilluft: number;
  flödeFrånluft: number;
  flödesKanalForm: "Cirkulära" | "Rektangulära";
  flödeKanalstorlekBxH?: string;
  flödeFrånluftDiameter?: number;

  driftÅretRunt: JaNej;
  delfartsFaktor: number;

  tempUteluft: number;

  tempTillLuftEfterÅtervinningsBat: number;
  tempTillLuftEfterEftervärmningssBat: number;
  tempTillLuftEfterEfterkylningssBat: number;

  tempFrånLuftInnanÅtervinningsBat: number;
  tempAvluftInnanVentilationsAgg: number;

  börvärdeRegTilluft: number;
  ärvärdeRegTilluft: number;

  kontrollmättTempRegTilluft: number;

  reglerTyp: string;

  //Utstyrning temperaturreglering ventilationsaggregat
  utstyrningVärmeåtervinning: number;
  utstyrningEftervärmning: number;
  utstyrningEfterkylning: number;
  kylÅtervinningAktiv: JaNej;
  //Kontroll luftfilter ventilationsaggregat
  uppmättSluttrycksfallFilterUteluft: number;
  larmSluttrycksfallFilterUteluftAktivt: JaNej;
  uppmättSluttrycksfallFilterFrånluft: number;
  larmSluttrycksfallFilterFrånluftAktivt: JaNej;

  //Tidschema ventilationsaggregat & verksamhet
  finnsOrsakerTillLångDrifttid: JaNej;
  nattkylaAktiverad: JaNej;
  ventilationStoppadPeriodvis: JaNej;
  antalVeckorVentilationStoppadPerÅr: number;
  antalVeckorVentilationSkulleKunnaVaraStoppad: number;

  tidsKanaler?: IModuleVentilationRoundTidskanaler;
}
// const tst: IModuleVentilationFTXochFT;

//   =>
//roundData.tidsKanaler.ventilation?.monday   : IPeriod[]
//roundData.tidsKanaler.närvaro?.friday   : IPeriod[]
// € monday -> sunday.

export interface IModuleVentilationFTXochFT extends IModuleVentilationFTXochFTConfig, IModuleVentilationFTXochFTRound {}

enum EnhetLuftflöde {
  LiterPerSekund = "Liter per sekund (l/s)",
  KubikmeterPerTimme = "Kubikmeter per timme (m3/h)",
}
//5.2.1 Ventilationsaggregat (FX+F- system)
// export enum FXVärmepumpTekniskModell {
//   Frånluftsvärmepump = "Frånluftsvärmepump",
//   "Frånluftsvärmepump med inverterstyrning" = "Frånluftsvärmepump med inverterstyrning",
// }
export interface IModuleVentilationFXochFConfig extends IModuleVärmePrimärPumpConfig {
  //Generell
  //värmepumpKopplad: string;
  // värmepumpTekniskModell: FXVärmepumpTekniskModell;   -> Värmepumpens config om FX!

  //Flöde

  harReduceradeLuftflödeFlödesreglering: "Ja" | "Nej";
  reduceratFlödeFlödesreglering: number;
  harReduceradeLuftflödeTryckreglering: "Ja" | "Nej";
  reduceratFlödeTryckreglering: number;
  variabeltFlödeReglermetod: string;
  //MotorEffekt
  motoreffektUppgift: string;
  motoreffektFrånluft: number;
}

export interface IModuleVentilationFXochFRound {
  //Flöde
  flödeUppgift: string;
  flödeEnhet: string;
  flödeFrånluft: number;
  flödesKanalForm: "Cirkulära" | "Rektangulära";
  flödeKanalstorlekBxH?: string;
  flödeFrånluftDiameter?: number;
  //Tidschema ventilationsaggregat & verksamhet
  driftÅretRunt: JaNej;
  delfartsFaktor: number;
  finnsOrsakerTillLångDrifttid: JaNej;
  nattkylaAktiverad: JaNej;
  ventilationStoppadPeriodvis: JaNej;
  antalVeckorVentilationStoppadPerÅr: number;
  antalVeckorVentilationSkulleKunnaVaraStoppad: number;

  tidsKanaler?: IModuleVentilationRoundTidskanaler;
}
export interface IModuleVentilationFXochF extends IModuleVentilationFXochFConfig, IModuleVentilationFXochFRound {}

//5.2.1 Ventilationsaggregat (FX+F- system)
export interface IModuleVentilationSConfig {
  //Generell
  ärSjälvdragsystemetHelaByggnaden: "Ja" | "Nej";
  betjänasAndel: number;
}
export interface IModuleVentilationSRound {}
export interface IModuleVentilationS extends IModuleVentilationSConfig, IModuleVentilationSRound {}

//
export interface IModuleNConfig {}
export interface IModuleNRound {}
export interface IModuleName extends IModuleNConfig, IModuleNRound {}

export enum Värmekällor {
  Fjärrvärme = "Fjärrvärme",
  Markvärmepump = "Markvärmepump",
  Frånluftsvärmepump = "Frånluftsvärmepump",
  FrånluftsvärmepumpMedInverterstyrning = "Frånluftsvärmepump med inverterstyrning",
  Biobränslepanna = "Biobränslepanna",
  VärmepumpLuftVatten = "Värmepump Luft / Vatten",
  VärmepumpLuftuft = "Värmepump Luft / Luft",
  Elpanna = "Elpanna",
  Gaspanna = "Gaspanna",
  Oljepanna = "Oljepanna",
  DirektverkandeEl = "Direktverkande EL",
}

export interface IAbonnemang {
  noOfBuildings: number;
  totalSurfaceArea: number;
}
